export enum AgentExecutor {
  PLATFORM = "PLATFORM",
  SETTINGS = "SETTINGS",
  DISPLAY_VISUALIZATION = "DISPLAY_VISUALIZATION",
  ASK_USER = "ASK_USER",
  PROPOSE_OPTIONS = "PROPOSE_OPTIONS",
  KNOWLEDGE_SEARCH = "KNOWLEDGE_SEARCH",
  ANALYTICS = "ANALYTICS",
}

export enum AgentExecutionKind {
  TOOL_CALL = "TOOL_CALL",
  QUERY = "QUERY",
  CODE = "CODE",
  PROGRESS = "PROGRESS",
}

export enum AgentExecutionStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

/** Latest persisted snapshot of one agent operation attempt. */
export interface AgentExecution {
  id: string;
  chatHistoryId: string;
  parentExecutionId?: string | null;
  sequence: number;
  attempt: number;
  executor: AgentExecutor;
  operation: string;
  kind: AgentExecutionKind;
  status: AgentExecutionStatus;
  externalCallId?: string | null;
  input?: Record<string, unknown> | unknown[] | null;
  output?: Record<string, unknown> | unknown[] | null;
  error?: Record<string, unknown> | unknown[] | null;
  summary?: string | null;
  startedAt?: string | null;
  completedAt?: string | null;
}
